import { Link } from 'react-router-dom';
import { latestNews } from '@/mocks/home';

const newsImages: Record<string, string> = {
  'news-premier-league': 'https://readdy.ai/api/search-image?query=Premier%20League%20football%20trophy%20in%20dramatic%20stadium%20spotlight%20with%20dark%20atmosphere%2C%20professional%20product%20photography%2C%20warm%20golden%20lighting%20on%20trophy%2C%20editorial%20quality&width=800&height=500&seq=news-premier-league&orientation=landscape',
  'news-nba-trade': 'https://readdy.ai/api/search-image?query=NBA%20team%20jerseys%20dramatically%20arranged%20on%20dark%20basketball%20court%20with%20spotlight%20effects%2C%20professional%20sports%20photography%2C%20warm%20lighting%2C%20editorial%20quality&width=800&height=500&seq=news-nba-trade&orientation=landscape',
  'news-us-open': 'https://readdy.ai/api/search-image?query=Tennis%20racket%20and%20balls%20on%20blue%20hard%20court%20at%20sunset%20with%20golden%20hour%20lighting%2C%20elegant%20sports%20photography%2C%20warm%20atmosphere%2C%20clean%20composition&width=800&height=500&seq=news-us-open&orientation=landscape',
  'news-beginner-guide': 'https://readdy.ai/api/search-image?query=Modern%20elegant%20sports%20analytics%20workspace%20with%20laptop%20and%20notebook%2C%20warm%20ambient%20lighting%2C%20dark%20wood%20desk%2C%20professional%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=news-beginner-guide&orientation=landscape',
  'news-esports': 'https://readdy.ai/api/search-image?query=Professional%20gaming%20arena%20with%20colorful%20RGB%20lights%20and%20dark%20atmosphere%2C%20futuristic%20setup%2C%20energetic%20competitive%20gaming%20vibe%2C%20wide%20angle%2C%20editorial%20quality&width=800&height=500&seq=news-esports&orientation=landscape',
  'news-app-upgrade': 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20sports%20app%20interface%20on%20dark%20elegant%20background%2C%20minimal%20product%20photography%2C%20warm%20accent%20lighting%2C%20clean%20composition&width=800&height=500&seq=news-app-upgrade&orientation=landscape',
};

export default function LatestNews() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新赛事资讯
            </h2>
            <p className="text-foreground-600 text-sm">专业分析 · 深度解读</p>
          </div>
          <Link
            to="/category/football"
            className="whitespace-nowrap flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestNews.map((news) => (
            <Link
              key={news.id}
              to={`/article/${news.id}`}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={newsImages[news.imageSeq]}
                  alt={news.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  title={news.title}
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="whitespace-nowrap px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {news.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{news.date}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {news.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {news.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}